function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import React, { Component, Suspense, lazy } from 'react';
import memoize from 'memoize-one';
import { connect } from 'react-redux';
import { getClosedPanelsForDashboard, LayoutUtils, PanelEvent } from '@deephaven/dashboard';
import Log from '@deephaven/log';
import { assertNotNull } from '@deephaven/utils';
import { LoadingOverlay } from '@deephaven/components';
import Panel from "./CorePanel.js";
import MarkdownContainer from "../controls/markdown/MarkdownContainer.js";
import MarkdownStartPage from "../controls/markdown/MarkdownStartPage.js";
import "./MarkdownPanel.css";
import MarkdownUtils from "../controls/markdown/MarkdownUtils.js";
import { jsx as _jsx } from "react/jsx-runtime";
var MarkdownEditor = /*#__PURE__*/lazy(() => import('../controls/markdown/MarkdownEditor'));
var log = Log.module('MarkdownPanel');
export class MarkdownPanel extends Component {
  constructor(props) {
    super(props);
    _defineProperty(this, "markdownEditor", void 0);
    _defineProperty(this, "editor", void 0);
    _defineProperty(this, "getClosedMarkdowns", memoize(MarkdownUtils.getClosedMarkdowns));
    this.handleContainerDoubleClick = this.handleContainerDoubleClick.bind(this);
    this.handleCreateMarkdown = this.handleCreateMarkdown.bind(this);
    this.handleDeleteMarkdown = this.handleDeleteMarkdown.bind(this);
    this.handleOpenMarkdown = this.handleOpenMarkdown.bind(this);
    this.handleEditorInitialized = this.handleEditorInitialized.bind(this);
    this.handleEditorBlur = this.handleEditorBlur.bind(this);
    this.handleEditorResize = this.handleEditorResize.bind(this);
    var panelState = props.panelState;
    var content = null;
    if (panelState != null && panelState.content != null) {
      if (panelState.content !== '') {
        content = panelState.content;
      } else {
        content = MarkdownUtils.DEFAULT_CONTENT;
      }
    }
    this.state = {
      isStartPageShown: content == null && this.getClosedMarkdowns(props.closedPanels).length !== 0,
      isEditing: false,
      content,
      // eslint-disable-next-line react/no-unused-state
      panelState
    };
    this.markdownEditor = null;
  }
  setEditorPosition(clickPositionY) {
    assertNotNull(this.markdownEditor);
    var markdownEditorContainer = this.markdownEditor.container;
    if (this.editor && markdownEditorContainer != null) {
      var _this$editor$getModel, _this$editor$getModel2;
      var contentTop = markdownEditorContainer.getBoundingClientRect().top;
      var contentScrollTop = markdownEditorContainer.scrollTop;
      var contentScrollHeight = markdownEditorContainer.scrollHeight;
      var totalLines = (_this$editor$getModel = (_this$editor$getModel2 = this.editor.getModel()) === null || _this$editor$getModel2 === void 0 ? void 0 : _this$editor$getModel2.getLineCount()) !== null && _this$editor$getModel !== void 0 ? _this$editor$getModel : 0;
      var lineToFocus = Math.round((contentScrollTop + clickPositionY - contentTop) / contentScrollHeight * totalLines);
      if (lineToFocus > totalLines) {
        lineToFocus = totalLines;
      }
      this.editor.revealLine(lineToFocus);
      this.editor.setPosition({
        lineNumber: lineToFocus,
        column: 1
      });
      this.editor.focus();
    }
  }
  handleContainerDoubleClick(event) {
    var isEditing = this.state.isEditing;
    var dbClickPositionY = event.clientY;
    if (!isEditing) {
      this.setState({
        isEditing: true
      }, () => {
        this.setEditorPosition(dbClickPositionY);
      });
    }
  }
  handleEditorInitialized(editor) {
    log.debug('Markdown Editor Initialized...');
    this.editor = editor;
  }
  handleCreateMarkdown() {
    log.debug('create markdown...');
    this.setState({
      isStartPageShown: false,
      content: '',
      isEditing: true,
      // eslint-disable-next-line react/no-unused-state
      panelState: {
        content: ''
      }
    }, () => {
      if (this.editor != null && this.editor.focus != null) {
        this.editor.focus();
      }
    });
  }
  handleOpenMarkdown(markdown) {
    log.debug('open markdown...', markdown);
    var _this$props = this.props,
      glContainer = _this$props.glContainer,
      glEventHub = _this$props.glEventHub;
    var config = LayoutUtils.getComponentConfigFromContainer(glContainer);
    glEventHub.emit(PanelEvent.REOPEN, markdown, config);
  }
  handleDeleteMarkdown(markdown) {
    var glEventHub = this.props.glEventHub;
    glEventHub.emit(PanelEvent.DELETE, markdown);
  }
  handleEditorBlur(event) {
    var _this$editor;
    log.debug("markdown content changed, saving...");
    var isEditing = this.state.isEditing;

    // if not in edit mode, or in edit mode but blur went to an internal monaco field (like search)
    if (!isEditing || this.markdownEditor != null && this.markdownEditor.container != null && this.markdownEditor.container.contains(event.relatedTarget)) {
      return;
    }
    var content = (_this$editor = this.editor) === null || _this$editor === void 0 ? void 0 : _this$editor.getValue();
    this.setState({
      content,
      isEditing: false,
      // eslint-disable-next-line react/no-unused-state
      panelState: {
        content
      }
    });
  }
  handleEditorResize() {
    var isEditing = this.state.isEditing;
    if (isEditing && this.editor) {
      this.editor.layout();
    }
  }
  render() {
    var _this$props2 = this.props,
      glContainer = _this$props2.glContainer,
      glEventHub = _this$props2.glEventHub,
      closedPanels = _this$props2.closedPanels;
    var _this$state = this.state,
      isEditing = _this$state.isEditing,
      isStartPageShown = _this$state.isStartPageShown,
      content = _this$state.content;
    var closedMarkdowns = this.getClosedMarkdowns(closedPanels);
    return /*#__PURE__*/_jsx(Panel, {
      glContainer: glContainer,
      glEventHub: glEventHub,
      className: "markdown-panel",
      componentPanel: this,
      onResize: this.handleEditorResize,
      onBlur: this.handleEditorBlur,
      isClonable: true,
      isRenamable: true,
      children: isStartPageShown ? /*#__PURE__*/_jsx(MarkdownStartPage, {
        closedMarkdowns: closedMarkdowns,
        onCreate: this.handleCreateMarkdown,
        onOpen: this.handleOpenMarkdown,
        onDelete: this.handleDeleteMarkdown
      }) : /*#__PURE__*/_jsx(MarkdownContainer, {
        isEditing: isEditing,
        onDoubleClick: this.handleContainerDoubleClick,
        children: /*#__PURE__*/_jsx(Suspense, {
          fallback: /*#__PURE__*/_jsx(LoadingOverlay, {
            "data-testid": "markdown-panel-loading"
          }),
          children: /*#__PURE__*/_jsx(MarkdownEditor, {
            ref: markdownEditor => {
              this.markdownEditor = markdownEditor;
            },
            isEditing: isEditing,
            content: content !== null && content !== void 0 ? content : MarkdownUtils.DEFAULT_CONTENT,
            onEditorInitialized: this.handleEditorInitialized
          })
        })
      })
    });
  }
}
_defineProperty(MarkdownPanel, "defaultProps", {
  panelState: null
});
_defineProperty(MarkdownPanel, "COMPONENT", 'MarkdownPanel');
var mapStateToProps = (state, ownProps) => {
  var localDashboardId = ownProps.localDashboardId;
  return {
    closedPanels: getClosedPanelsForDashboard(state, localDashboardId)
  };
};
var ConnectedMarkdownPanel = connect(mapStateToProps, null, null, {
  forwardRef: true
})(MarkdownPanel);
export default ConnectedMarkdownPanel;
//# sourceMappingURL=MarkdownPanel.js.map